import { useGnomeAssetPreload } from "../../../logic/hooks/useGnomeAssetPreload";

export function GnomeAssetPreloadRuntime() {
    // Warm only bytes after the hook's readiness, access and connection checks.
    // Decode, parsing and renderer creation remain foreground work.
    useGnomeAssetPreload("bytes");
    return null;
}
